import WhatShouldAvoidWhenPlanning from '$/_const/dna/WhatShouldAvoidWhenPlanning.ts';

const legacyValues: readonly string[] = [
  WhatShouldAvoidWhenPlanning.TOURIST_TRAPS,
  WhatShouldAvoidWhenPlanning.CROWDS,
  WhatShouldAvoidWhenPlanning.EARLY_MORNINGS,
  WhatShouldAvoidWhenPlanning.CHAIN_RESTAURANTS,
  WhatShouldAvoidWhenPlanning.SHARED_TRANSFERS,
  WhatShouldAvoidWhenPlanning.NIGHTLIFE,
];

type AvoidanceDna = {
  what_should_avoid_when_planning?: readonly string[] | null;
  what_should_avoid_when_planning_details?: Partial<Record<string, string[]>> | null;
  what_should_avoid_when_planning_custom?: string | null;
};

export const isLegacyAvoidValue = (value: string): boolean => legacyValues.includes(value);

export const categoriesWithChoices = (
  details: Partial<Record<string, string[]>>,
  legacy: string[],
  visibleCategories: readonly string[]
): string[] => [
  ...visibleCategories.filter((category) => (details[category]?.length ?? 0) > 0),
  ...legacy.filter((value) => !visibleCategories.includes(value)),
];

export const avoidLabels = (
  dna: AvoidanceDna | null | undefined,
  t: (key: string, fallback: string) => string
): string[] => {
  const details = dna?.what_should_avoid_when_planning_details ?? {};
  const detailLabels = Object.entries(details).flatMap(([category, items]) =>
    (items ?? []).map((detail) => t(`travelDnaPage.yourDefaults.details.${category}.${detail}`, detail))
  );
  const legacyLabels = (dna?.what_should_avoid_when_planning ?? [])
    .filter((item) => isLegacyAvoidValue(item) && (details[item]?.length ?? 0) === 0)
    .map((item) => t(`travelDnaPage.whatShouldAvoidWhenPlanning.${item}`, item));
  const custom = dna?.what_should_avoid_when_planning_custom;

  return [...detailLabels, ...legacyLabels, ...(custom ? [custom] : [])];
};

export const savedCategories = (
  current: readonly string[],
  details: Partial<Record<string, string[]>>,
  visibleCategories: readonly string[]
): string[] =>
  categoriesWithChoices(
    details,
    current.filter((value) => !visibleCategories.includes(value)),
    visibleCategories
  );
